import * as React from 'react';
import { Toolbar, Typography, Paper, TextField } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Dropdown, { ICustomDropdownOption } from '../CustomDropdown';
import { ITableMenuAction } from '.';
import GenericInput from '../input-components/GenericTextInput';
import { ITableFilterType, TableFilterTypes} from './index-filter';
import { ta } from 'date-fns/locale';
import GenericSelectInput from '../input-components/GenericSelectInput';
import GenericDateRangePicker from '../input-components/GenericDateRangePicker';

interface EnhancedTableToolbarProps {
  title: string;
  searchKey: string;
  selected: string[];
  actions?: ITableMenuAction[];
  onSearchUpdate: (v: string) => void;
  onFilterUpdate: (name: string, value: any) => void;
  filters?: ITableFilterType[];
}

const useStyles = makeStyles()(
  (_theme,) => ({
    toolbar: {
      display: "flex",
      justifyContent: "space-between",
      alignContent: "center",
      alignItems: "center",
      width: "100%",
      minHeight: "65px",
      flexWrap: "wrap"
    },
    leftSection: {
      display: "flex"
    },
    title: {
      display: "block",
      marginRight: "15px",
      color: '#fff'
    },
    searchField: {
      border: 'none',
      outline: 'none',
      // borderBottom: '1px solid rgba(224, 224, 224, 1)',
      fontSize: "16px",
      padding: "0 0 2px",
      margin: "0 0 0 0",
      color: "white"
      
    },
    searchFieldWrapper: {
      margin: "0 15px 0 0"
    },
    dropdownButton: {
      backgroundColor: "#6e759f",
      '&:hover': {
        backgroundColor: "#565c81",
      },
    }
  })
);

const EnhancedTableToolbar: React.FC<EnhancedTableToolbarProps> = ({ searchKey, selected, actions = [], onSearchUpdate, filters, onFilterUpdate,}) => {
  const { classes, cx } = useStyles();


  const dropdownOption: ICustomDropdownOption[] = actions.map((action) => {
    return {
      key: action.key,
      title: action.title,
      onClick: () => { action.onClick(selected) },
      disabled: action.disabled(selected)
    }
  });

  const renderFilters = () => {
    return filters.map((filter) => {
      if (filter.type === TableFilterTypes.SELECT) {
        return (
          <GenericSelectInput
            key={filter.name}
            title={filter.title}
            value={filter.value || []}
            onChange={(value) => onFilterUpdate(filter.name, value)}
            items={filter.options || {}}
            multiple
            name={filter.name} type={''}          />
        );
      }
      if (filter.type === TableFilterTypes.DATERANGE) {
        return (
          <GenericDateRangePicker
            key={filter.name}
            title={filter.title}
            value={filter.value || []}
            onChange={(value) => onFilterUpdate(filter.name, value)}
            name={filter.name}
          />
        );
      }
      return null;
    });
  };

  return (
    <Toolbar className={classes.toolbar}
    style={{
      padding: '10px 16px',
      display: 'flex',
      gap: '10px',
      alignItems: 'center'

    }}>
      <div className={classes.leftSection}>
        {/* <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
          {title}
        </Typography> */}
        <GenericInput containerClassName={classes.searchFieldWrapper} hideError={true} title="" name="" size="small" value={searchKey} type='text' placeholder='Search...' className={classes.searchField} onChange={(v) => {onSearchUpdate(v)}} />
      </div>

      {
        actions && actions.length > 0 ? 
        <Dropdown
          title="Actions"
          options={dropdownOption}
          className={classes.dropdownButton}
        /> : <span />
      }

      {
        filters && filters.length > 0 ? renderFilters() : <span />
      }

    </Toolbar>
  );
};

export default EnhancedTableToolbar;
